module.exports = __webpack_public_path__ + "img/map-colony.a0031410.png";